export const trackAnalytics = (event: string, extraDimensions: object = {}) => {
  try {
    const dimensions = {
      source: "saleslead",
      ...extraDimensions,
    };
    window.xdk?.analytics?.track?.(event, dimensions);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error tracking with google analytics error", error);
  }
};
